import { render, staticRenderFns } from "./RetakeRuleSetting.vue?vue&type=template&id=65fd052b"
import script from "./RetakeRuleSetting.vue?vue&type=script&lang=js"
export * from "./RetakeRuleSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports